import Phaser from 'phaser';
import { GAME } from '../config';
import { BgmPlayer } from '../audio/bgm-player';

export class EndingScene extends Phaser.Scene {
  private music!: BgmPlayer;

  constructor() { super('EndingScene'); }

  create(): void {
    this.cameras.main.setBackgroundColor('#000000');

    this.add.text(GAME.width / 2, 100, '🎊 你征服了永恆要塞 🎊', {
      fontSize: '36px',
      color: '#ffd54f',
      fontFamily: 'serif',
    }).setOrigin(0.5);

    const credits = [
      '感謝你的修煉。',
      '五門派的力量永遠與你同在。',
      '',
      '製作:Pata + AI 開發團隊',
      '美術:Kenney / CraftPix',
      '音樂:Kevin MacLeod',
      '',
      '(W4 真正的 Tier-3 boss 完成後此頁會大幅升級)',
    ];
    credits.forEach((line, i) => {
      this.add.text(GAME.width / 2, 200 + i * 36, line, {
        fontSize: '20px',
        color: '#cfd8dc',
        fontFamily: 'serif',
      }).setOrigin(0.5);
    });

    this.add.text(GAME.width / 2, GAME.height - 40, '[按任意鍵 / 點擊返回]', {
      fontSize: '14px',
      color: '#666666',
    }).setOrigin(0.5);

    const goHome = () => window.dispatchEvent(new CustomEvent('ef:return-home'));
    this.input.keyboard!.once('keydown', goHome);
    this.input.once('pointerdown', goHome);
    this.time.delayedCall(20000, goHome);

    this.music = new BgmPlayer();
    this.music.start();
    this.music.playEndingBgm();

    this.events.on('shutdown', () => this.music.stop());
  }
}
